import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { privacyPolicyData } from '../Common/PrivacyPolicyData';
import { useState } from 'react';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import ExtensionNavbar from './ExtensionNavbar';
import { YCFPrivacyPolicyData } from '../Common/YCFPrivacyPolicyData';

function YCFPrivacyPolicy(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 
    
    const privacyPolicyEle = YCFPrivacyPolicyData.map((ele, idx) => {
        return(
            <div className='ppEle' key={idx}>
                <div className='ppHeader'>{ele.header}</div>
                <div className='ppContent'>{ele.content}</div>
            </div>
        )
    });

    return(
        <div className='parentDiv'>
            <div className='mainDiv privacyPolicy'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Privacy Policy</div>
                        <div className='contentBox'>
                            <div className='content'>
                                {privacyPolicyEle}
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default YCFPrivacyPolicy;